import Type from './Type';
export function isILinkConditional(discourse) {
    return discourse.type === Type.Conditional;
}
export {
    isILinkConditional as isIConditional
};
export default isILinkConditional;    //# sourceMappingURL=isIConditional.js.map
